<template>
  <div class="forum">

    <TopicCard
      type="top"
      v-if="topTopics != null && Object.keys(topTopics).length > 0"
      :values="topTopics"
    />

    <div class="post-btn" style="display: flex;">
      <el-button type="primary" @click="handleTopicCreate">发帖</el-button>
      <Authorized permission="POST/ARTICLE">
        <el-button type="success" @click="handleArticleCreate" style="margin-left: 15px;">文章</el-button>
      </Authorized>

    </div>
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
      />
    </div>
    <TopicCard :values="topics" 
    @tag-click="handleTagClick"/>
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
      />
    </div>


    <Bind :bindTipFormVisible.sync="showBindTip">
    </Bind>

  </div>
</template>

<script>
import TopicCard from "@/components/TopicCard";

import Bind from "@/layout/components/Bind/index.vue";

import { getTopics, getTopTopics } from "@/service/post";
import { getForum } from "@/service/forum";
import Authorized from "@/components/Authorized";
import { mapGetters } from "vuex";
export default {
  components: {
    TopicCard,
    Authorized,
    Bind
  },
  data() {
    return {
      topTopics: null,
      topics: null,
      listLoading: true,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      showBindTip: false
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  watch: {
    $route() {
      this.getTopicsData();
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.getTopicsData();
    this.getTopTopicsData();
    this.getTheForum();
  },

  methods: {

    handleTagClick(tag){
      console.log('进入了方法',tag)
      const current = 1
      const id = this.$route.params.id ? this.$route.params.id : -1;
      const filter = this.$route.query.filter ? this.$route.query.filter : null
      if(filter){
        // 有查询条件
        this.$router.push(`/forum-${id}-${current}.html?filter=${filter}` + `&tag=` + tag);
      }else{
        this.$router.push(`/forum-${id}-${current}.html?tag=` + tag);
      }
    },
    handleTopicCreate() {
      if(this.user && this.user.postStatus == 'CLOSED'){
        // 不给发帖,引导到实名认证页面
        this.showBindTip = true
      }else{
        const id = this.$route.params.id ? this.$route.params.id : -1;
        this.$router.push(`/topic_create?forum_id=` + id);
      }
    },
    handleArticleCreate() {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      this.$router.push(`/article/create?forum_id=` + id);
    },
    handleCurrentChange(current) {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      const filter = this.$route.query.filter ? this.$route.query.filter : null
      if(filter){
        // 有查询条件
        this.$router.push(`/forum-${id}-${current}.html?filter=${filter}`);
      }else{
        this.$router.push(`/forum-${id}-${current}.html`);
      }
    },
    getTheForum() {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      getForum(id)
        .then((response) => {
          if (response.code === 0) {
            const data = response.data;
            this.$store.dispatch("app/setBreadcrumb", [
              {
                key: 1,
                link: "/forums/" + data.pforum.aliase + ".html",
                value: data.pforum.name,
              },
              {
                key: 2,
                link: "/forum-" + data.id + "-1.html",
                value: data.name,
              },
            ]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getTopicsData() {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      const current = this.$route.params.current
        ? this.$route.params.current
        : 1;
      const filter = this.$route.query.filter ? this.$route.query.filter : null;
      const tag = this.$route.query.tag ? this.$route.query.tag : null;
      //todo 超过5页需要登录

      getTopics({
        forumId: id,
        current,
        filter,
        tag
      })
        .then((response) => {
          if (response.code === 0) {
            this.topics = response.data.records;
            this.total = response.data.total;
            this.pageSize = response.data.size;
            this.currentPage = response.data.current;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getTopTopicsData() {
      const id = this.$route.params.id ? this.$route.params.id : -1;
      getTopTopics(id)
        .then((response) => {
          if(response.code === 0){
            this.topTopics = response.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="less">
.post-btn {
  margin-top: 40px;
  margin-bottom: 10x;
  text-align: left;
}
</style>
